// extracted by mini-css-extract-plugin
module.exports = {"pokemonCard":"styles_pokemonCard__3Eioy","row":"styles_row__Fu2rV"};